import React from 'react'

const UserDashboardNotifications = () => {
	return <div>UserDashboardNotifications</div>
}

export default UserDashboardNotifications
